<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kaKBNx/tc-custom/9780814351123.jpg?1726073140379" alt="This image is the cover for the book Diver Beneath the Street, Made in Michigan Writers Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Diver Beneath the Street, Made in Michigan Writers Series
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>True crime meets ecopoetry at the level of the soil, bringing together life and death.</b> </p><p>A decaying psychogeography unfurls the landscapes of the 1967–69 Michigan Murders, the 2019 Detroit serial killer, and the COVID-19 lockdown in this visceral poetry collection. Author, performance artist, and disability culture activist Petra Kuppers dissects traces of violence in the richness of the soil while honoring lost community members. Dynamic and somatic poems traverse the realms of urban space, wild rivers, and the hinterlands of suburbia, glimpsing the decay of bodies, houses, carpets, hair, and bones by way of ecopoetry. Poems like "Reintegration" and "Earth Séance" delve into cycles of decomposition and decreasing biodiversity across the micro- and macroworlds. Others such as "Dancing Princesses" tie timeless fairy-tale tropes of violence toward women to modern murders and lived experience. Moments in lockdown are embodied through somatic exploration of nature and self in works like "Dear White Pine in My Garden." This evocative entanglement of life and death, joy and horror, natural and artificial processes and particles offers an intriguing lyrical and poetic quality as well as unique perspectives through the lenses of feminist, queer, and disability studies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Petra Kuppers
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09acad03